<template>
  <v-main fill-height class="page-main"
          :style="{'background-image' : `url(${getImage(background)})`}">
    <v-container fluid class="flex-fill pos-relative" :style="!bottomSheetOpen? 'z-index:4': ''">
      <div class="main-top">
        <v-btn icon :class="[{'new': noticNew},'btn-notice']" @click="notification"></v-btn>
        <!--        <div @click="notification" class="pos-relative">-->
        <!--          <NoticIcon/>-->
        <!--        </div>-->
        <!-- 삼성 화재용 로고 -->
        <div v-if="isSamsungFire" class="customer-logo" @click="clickLogo">
          <img :src="getImage(logo)"/>
        </div>
        <!-- 삼성 화재용 로고 -->
      </div>

      <div class="greetings">
        <vue-typer :text='greetingsText'
                   :repeat='Infinity'
                   :shuffle='false'
                   initial-action='typing'
                   :pre-type-delay='120'
                   :type-delay='120'
                   :pre-erase-delay='2500'
                   :erase-delay='230'
                   erase-style='clear'
                   :erase-on-complete='false'
                   caret-animation='blink'
        />
        <!-- 기본 박스 사이즈 잡아주는 부분 -->
        <div class="greetings-hidden">{{ greetingsText }}</div>
      </div>

      <!-- <a href="/user/push-test-page">푸시테스트페이지로 이동</a> -->
<!--      <v-btn @click="isShowCoachMark = !isShowCoachMark">코치마크 열기</v-btn>-->

      <div class="my-travel-status" :class="{ 'night' : !dayOrNight }">
        <template v-if="(hasActiveTrial && expiredTrial && !(expiredTrialTicket && useOrdDtlIsNull)) || (endedTrial && ticketList.length === 0)">
          <v-btn text depressed @click="() => (endedTrial && ticketList.length === 0) ? movePage('/fo/myTicket') : dispatchBalanceCheckAvailable()">
            {{ hasActiveTrial && expiredTrial ? '보유 체험권 이어하기' : '티켓을 구매하고 새로운 마음여행을 떠나보세요.'}}
          </v-btn>
          <br>
        </template>
        <template v-else-if="travelYn === 'Y' || travelStopYn === 'Y'">
          <v-btn text depressed @click="solutionPause()">
            {{ travelText }}
          </v-btn>
          <br>
        </template>
        <template v-else-if="isSamsungFire">
          <template v-if="ticketList !== null">
            <template v-if="ticketList.length">
              <v-btn v-if="isApplResult === 'success' && noGuide === true"
                     text depressed
                     @click="guideSelect()">여행을 시작하세요<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'success' && isBeforeApplResultYn && remainCnt > 0 && usePsbYn === 'Y'"
                     text depressed
                     @click="ticketStart">보유 티켓으로 여행을 떠나보세요.<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'fail' || !isBeforeApplResultYn"
                     text depressed
                     @click="getMemberStepCnt">여행지원서 작성하러가기<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'success' && isBeforeApplResultYn && (remainCnt <= 0  || usePsbYn === 'N')"
                     text depressed
                     @click="movePage('/fo/suitcase');">나의 마음나무 보러가기<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
            </template>
            <template v-else>
              <v-btn v-if="isApplResult === 'success' && noGuide === true"
                     depressed plain
                     @click="guideSelect ()">여행을 시작하세요<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'success' && isBeforeApplResultYn"
                     text depressed
                     @click="movePage('/fo/suitcase');">나의 마음나무 보러가기<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'fail' || !isBeforeApplResultYn"
                     text depressed
                     @click="getMemberStepCnt">여행지원서 작성하러가기<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
            </template>
          </template>
        </template>
        <template v-else>
          <template v-if="ticketList !== null">
            <template v-if="ticketList.length">
              <v-btn v-if="isApplResult === 'success' && this.noGuide == true"
                     text depressed
                     @click="guideSelect()">여행을 시작하세요<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'success' && isBeforeApplResultYn"
                     text depressed
                     @click="ticketStart">보유 티켓으로 여행을 떠나보세요.<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'fail' || !isBeforeApplResultYn"
                     text depressed
                     @click="getMemberStepCnt">여행지원서 작성하러가기<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
            </template>
            <template v-else>
              <v-btn v-if="isApplResult === 'success' && noGuide === true"
                     text depressed
                     @click="guideSelect()">여행을 시작하세요<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'success' && isBeforeApplResultYn && memberGb === '01'"
                     text depressed
                     @click="movePage('/fo/suitcase');">나의 마음나무 보러가기<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'success' && isBeforeApplResultYn"
                     text depressed
                     @click="ticketStart">티켓 구매 후, 여행을 떠나보세요.<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
              <v-btn v-else-if="isApplResult === 'fail' || !isBeforeApplResultYn"
                     text depressed
                     @click="getMemberStepCnt">여행지원서 작성하러가기<i class="ez-dms-arr-right-md ms-2"></i>
              </v-btn>
            </template>
          </template>
        </template>
      </div>

      <!-- MissionMain 참고 -->
      <MissionAchievement :value="progressRate"
                          type="main"
                          class="mt-2"
                          v-if="travelYn === 'Y' && loadedTotalMissionRate"
                          @onClick="movePage('/fo/travelMap')"
      />
    </v-container>

    <MainBottomSheet @bottomSheetState="bottomSheetState" :isTravelMap="isTravelMap" :solutionComplete="solutionComplete"/>
    <BottomMenu/>
    <!-- 중간/사후 모달 flag=0 (중간) / flag=1 (사후) -->
    <ExaminationSheet :sheet="examinationSheetOpen" :flag="examinationSheetFlag" @examination="examination"
                      @sheetClose="sheetClose"/>
    <!-- 중간검사 유도 모달 -->
    <TravelApplicationSheet :sheet="travelApplicationSheetOpen" @sheetClose="travelApplicationSheetOpen = false"/>
    <!-- Snackbars -->
    <Snackbars ref="toastAfter" @snackbarClick="snackbarClickAfter"/>
    <!-- 코치 마크 -->
    <CoachMark beginner v-if="isShowCoachMark" @close="closeCoachMark" />
    <!-- 이벤트 팝업 -->
    <ModalEvent v-if="isShowPopup" />
  </v-main>

</template>

<script>
import store from '@/store'
import MissionAchievement from '@/components/mission/Achievement.vue'
import {mixinAuth, mixinRemote, mixinTicket, mixinTravel, mixinTrial} from '@/mixins'
import MainBottomSheet from '@/components/layout/bottomSheet/MainBottomSheet'
import BottomMenu from '@/components/layout/BottomMenu'
import ExaminationSheet from '@/components/layout/bottomSheet/ExaminationSheet'
import TravelApplicationSheet from '@/components/layout/bottomSheet/TravelApplicationSheet'
import Snackbars from '@/components/layout/Snackbars.vue'
import ModalEvent from '@/components/layout/modal/ModalEvent.vue'
import VueCookies from 'vue-cookies'
import Util from '@/utils/utils'
export default {
  components: {
    ModalEvent,
    MissionAchievement,
    MainBottomSheet,
    BottomMenu,
    ExaminationSheet,
    TravelApplicationSheet,
    Snackbars,
    CoachMark: () => import('@/page/coachMark/CoachMark.vue')
  },
  mixins: [mixinAuth, mixinRemote, mixinTravel, mixinTicket, mixinTrial],
  data: () => ({
    isShowCoachMark: false,
    isShowPopup: false,
    value: 'recent',
    noticNew: false, // 신규 메세지가 있는 경우 true
    greetings: '',
    stateStr: ['여행 지원서 작성하러 가기'],
    bottomSheetOpen: false,
    examinationSheetOpen: false,
    examinationSheetFlag: 0,
    travelApplicationSheetOpen: false,
    memberNo: 0,
    travelApplNo: 1,
    travelApplStepCd: '0001',
    memberStepApplCnt: 0,
    ticketList: null,
    goTravelApplStepCd: '0001',
    usePsbYn: '',
    remainCnt: 0,
    ramdomText: '',
    noGuide: false,
    usePeriodDiff: 0,
    token: '',
    weatherStatus: null,
    isTravelMap: false,
    guideEvalOrdDtlNo: '',
    loadedTotalMissionRate: false,
    progressRate: 0 // 미션 수행률
  }),
  computed: {
    appVersions () {
      return store.state.client.appVersions
    },
    greetingsText() {
      if (this.ramdomText !== '' && this.ramdomText.length > 0) {
        let randomText = ``
        let randomTextNic = this.ramdomText.replace('OO', this.nickname)
        let randomTextArr = randomTextNic.split('|')
        for (let i = 0; i < randomTextArr.length; i++) {
          randomText = randomText + randomTextArr[i]
          if (i < randomTextArr.length - 1) {
            randomText = randomText + `\n`
          }
        }
        return randomText
      }
      if (this.nickname !== '') {
        return `${this.nickname}님의\n즐거운 여행을 기대합니다.`
      }
      // 이거 안해주면 props 최초에 받을때 validator에서 초기 error 잡음 공백을 줘서 string으로 인식되게끔 바꿔줌
      return ' '
    },
    dayOrNight() {
      let hour = new Date().getHours()
      return hour > 6 && hour < 20
    },
    logo() {
      if (this.dayOrNight) {
        // 낮 이미지 로고
        return 'logo_anyfit.png';
      }
      // 밤 이미지 로고
      return 'logo_anyfit_white.png';
    },
    background() {
      if (this.isSamsungFire) {
        if (this.dayOrNight) {
          return 'background/hill/day.png';
        }
        return 'background/hill/night.png';
      } else {
        // if (this.clientCd === 'naver') {
        if (this.dayOrNight) {
          return 'background/space/day_ezn.gif';
          // return 'background/sea/day_ezn.gif';
          // return 'background/hill/day_ezn.gif';
          // }
        }
        return 'background/space/night_ezn.gif';
        // return 'background/sea/night_ezn.gif';
        // return 'background/hill/night_ezn.gif';
      }
    },
    travelText() {
      if (this.travelStopYn === 'Y') {
        return this.usePeriodDays + '일째 이용 중, 잠시 쉬고 있어요 >'
      } else {
        return ' 현재 ' + this.usePeriodDays + '일째 여행중입니다.'
      }
    }
  },
  created() {
    this.handleComponentEvent();

    if (this.travelYn === 'Y') this.getTotalMissionRate()
    // 메인 최초 진입인 경우 코치마크 튜토리얼 표시, 아니면 팝업 표시
    if (!this.memberInfo.tutorial) {
      this.isShowCoachMark = true
    } else {
      this.isShowPopup = true
    }
    if (this.hasActiveTrial && this.expiredTrial) this.continueTrial()
  },
  async mounted() {
    // 가장 최근의 여행지원서 결과 (사전검사) 여부 조회
    this.getBeforeAppResultList();

    this.getMemberApplResultLast();
    //솔루션 매핑여부 확인
    this.getMappingSolution();
    this.getMemberApplDiffMonth();
    await store.dispatch('getTravelMapOrdDtlList', this.$_payload('so', [{'ordStatus': '01'}, {'ordDtlStatus': '01'}]))
        .then(res => {
          if (res.success) {
            if (res.data.length > 0) {
              this.isTravelMap = true
            }
          } else {
            this.isTravelMap = false
          }
        })
        .catch(() => {
          // console.error(error);
          this.isTravelMap = false
        })
        .finally(() => {
        })
    await store.dispatch('getUseOrdDtl', true)
    // 가이드 만족도 검사 체크
    this.goGuideEval()
    await store.dispatch('getUserSltCmplt')
    await store.dispatch('getUserGuideImageNumber')
    if (this.isSamsungFire) {
      //유저 삼성 티켓 리스트 API
      this.getFireTicketList()
      //삼성 티켓 체크
      this.getFireTicketCheck()
    } else {
      //유저 티켓 리스트 API
      this.getTicketList()
    }
    //메인 랜덤 문구
    this.getMainText()
    //티켓 선택 후 가이드 및 찐한대화 일정 미입력 여부
    this.getUseOrdDtlNoGuide()
    //새알람 갯수
    this.getMemberNewAlarmCnt()

    // NOTE native event callback
    window.callbackDeviceInfo = this.callbackDeviceInfo
    this.updateApp()

    // firebase token update
    // 앱배포 후 삭제예정
    window.callbackToken = (token) => {
      this.token = token.replace('Optional("', '').replace('")', '')
      this.updateToken(this.token)
    }
    this.getPushToken()

  },
  methods: {
    getPushToken() {
       const userAgent = navigator.userAgent.toLowerCase();
       // console.log('userAgent : ', userAgent)
       if (userAgent.indexOf('android') >= 0) {
         // console.log('android 진입')
         let token = window.AndroidInterface.getFCMToken()
         // console.log(token)
         this.token = token
         this.updateToken(token)
       } else {
         window.webkit.messageHandlers.getFCMToken.postMessage('1234')
       }
     },
    updateApp() {
      const userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.indexOf('dms-user-app') >= 0) { // 후유 앱일 경우
        try {
          if (userAgent.indexOf('android') >= 0) {
            window.AndroidInterface.getDeviceInfo()
          } else {
            window.webkit.messageHandlers.getDeviceInfo.postMessage('정보조회')
          }
        } catch (e) {
          this.callbackDeviceInfo(null, null, false, userAgent.indexOf('android') >= 0)
        }
      }
    },
    callbackDeviceInfo(token, version, success, android) {
      if (token) this.updateToken(token, android)

      let targetVersionApp = this.appVersions.find(x => x.platform === (android ? 'AOS' : 'IOS'))
      if ((!success && !version) || (targetVersionApp && version < targetVersionApp.version)) {
        let updateMsg = targetVersionApp.updateMsg ? targetVersionApp.updateMsg : '후유 앱 업데이트가 필요합니다.<br>업데이트를 하지 않으실 경우 서비스 이용에 불편이 있으실 수 있습니다.'
        if (targetVersionApp.required) {
          const html = `<div class="alert-temp-01">
            <h6 class="tit">후유 업데이트 안내</h6>
            <p class="sub-txt ma-0">${updateMsg}</p></div>`
          this.$alert(html, {
            actions: {
              true: {
                text: '업데이트 하기', handle: () => {
                  if (android) {
                    window.open('https://play.google.com/store/apps/details?id=com.ezn.dms.user&hl=ko')
                  } else {
                    window.open('itms-apps://itunes.apple.com/app/id1671479927')
                  }
                }
              },
            },
            html: true // HTML 렌더링 활성화
          })
        } else {
          // 필수가 아닐때는 cookie 에 담아서 가끔 보여주도록...
          if (!VueCookies.isKey('dms-alarm-app')) {
            VueCookies.set('dms-alarm-app', true, Util.Common.getLocalStorage('expireSessionTime'))

            const html = `<div class="alert-temp-01">
              <h6 class="tit">후유 업데이트 안내</h6>
              <p class="sub-txt ma-0">${updateMsg}</p></div>`
            this.$alert(html, {
              actions: {
                true: {
                  text: '업데이트 하기', handle: () => {
                    if (android) {
                      window.open('https://play.google.com/store/apps/details?id=com.ezn.dms.user&hl=ko')
                    } else {
                      window.open('itms-apps://itunes.apple.com/app/id1671479927')
                    }
                  }
                },
                false: {
                  text: '취소', handle: () => {}
                },
              },
              html: true // HTML 렌더링 활성화
            })
          }
        }
      }
    },
    handleComponentEvent() {
      // if (userAgent.indexOf('android') >= 0 && userAgent.indexOf('dms_user_app') >= 0) {
      const {openTodayPlan = 0} = this.$route.query
      if (openTodayPlan * 1 > 0) {
        this.solutionComplete = true;
      }
    },
    clickLogo() {
      if (this.anifitProUrl === '/user/logout') {
        store.dispatch('logout')
      } else {
        window.open(this.anifitProUrl)
      }
    },
    notification() {
      this.movePage('/fo/notic');
    },
    goTravelPage(type) {
      // travelApplStepCd = 사전검사(0001), 중간검사(0002), 사후검사(0003)
      // startType = 단계별 처음(S), 단계별 다시시작(R)
      // 단계별 다시시작은 각 검사 단계의 결과까지 보았으나 다시 검사를 하는 경우 사용한다.
      this.$router.push({name: "travelIntro", query: {travelApplStepCd: this.travelApplStepCd, startType: type}});
    },
    bottomSheetState(flag) {
      this.bottomSheetOpen = flag;
    },
    sheetClose() {
      this.examinationSheetOpen = false
      this.travelToastOpen('travelToast')
    },
    travelToastOpen(cookie) {
      if (this.usePeriodDiff === 0) {
        this.$refs.toastAfter.toastOpen('bottom', '여행의 마지막 날입니다.', cookie, 'travelToastOpen', '사후 검사하기')
      } else {
        this.$refs.toastAfter.toastOpen('bottom', '사후검사 가능 기간이 ' + this.usePeriodDiff + '일 남았습니다', cookie, 'travelToastOpen', '사후 검사하기')
      }
    },
    examinationOpen(flag) {
      this.examinationSheetFlag = flag;
      this.examinationSheetOpen = true;
    },
    examination(flag) {
      /* 중간/사후 모달 flag=0 (중간) / flag=1 (사후) */
      this.examinationSheetOpen = false;
      let stepCd = '';
      if (flag === 1) {
        stepCd = '0003'
      } else {
        stepCd = '0002'
      }
      this.$router.push({
        name: "travelIntro",
        query: {
          travelApplStepCd: stepCd,
          startType: 'S',
          ordDtlNo: this.useOrdDtl.ordDtlNo
        }
      });
    },
    ticketStart() {
      //여행 시작하기 전 다시체크
      if (this.isSamsungFire) {
        this.getFireTicketCheck('Y') //삼성화재인 경우 체크추가
      } else {
        if (this.noGuide === false) {
          //티켓 사용
          this.movePage('/fo/ticketSelectEzn');
        } else {
          if (store.state.client.contract.allowsRealtalkService) {
            //가이드 선택
            this.movePage('/fo/guideSelect');
          }
        }
      }
      //TODO EZN 개발진행 시 재결제 변경,유지 모달창 추가예정
      //this.movePage('/user/fo/guideSelect');
    },
    ticketCheck(useYn) {
      if (this.usePsbYn === 'N') { //유효기간 D-85일 이하 이면 사용 불가 가용가능(Y), 불가능(N)
        this.$alert(`집중관리(상담) 티켓은 서비스 종료 전</br> 3개월까지만 발급 가능합니다.</br> 기업체 담당자에게 문의해주세요.`)
      } else if (this.weatherStatus.stateCd == '01') {
        this.$alert(`마음날씨가 '쨍쨍'인 경우,</br> 집중관리(상담)가 진행되지 않습니다.</br> 집중관리(상담)가 필요한 경우가 생기면,</br> 다시 여행 지원서를 작성해 보세요.`)
      } else if (this.remainCnt <= 0) {
        this.$alert(`집중관리(상담) 받을 수 있는</br> 기회가 선착순으로 마감되었습니다.</br> 기업체 담당자에게 문의해 주세요.`)
      } else {
        if (useYn === 'Y') {
          if (this.noGuide === false) {
            //티켓 사용
            this.movePage('/fo/ticketSelect');
          } else {
            //TODO. 수정 해야함
            if (!store.state.client.contract.allowsRealtalkService) {
              this.movePage('/fo/ticketSelect');
            } else {
              //가이드 선택
              this.movePage('/fo/guideSelect');
            }
          }
        }
      }
    },
    async getFireTicketCheck(useYn) {  // 유저 삼성 티켓 체크 API
      await store.dispatch('getFireTicketCheck')
          .then(res => {
            if (res.success && res.data != null) {
              this.usePsbYn = res.data.usePsbYn
              this.remainCnt = res.data.remainCnt
            } else {
              // console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
            this.usePsbYn = 'N'
            this.remainCnt = 0
          })
          .finally(() => {
            if (useYn === 'Y') {
              this.ticketCheck(useYn)
            }
          })
    },
    async getMemberApplResultLast() { // 여행지원서 마지막 결과 확인
      await store.dispatch('getMemberApplResultLast', this.$_payload('so', [{'travelApplNo': 1}]))
          .then(res => {
            if (res.success) {
              if (res.data !== null) {
                // 여행지원서 작성한 이력이 있으면 동의 처리. (동의 데이터 저장 X)
                store.commit('setTravelApplFormAgree', true)
                store.commit('setApplResultSuccess')

                this.goTravelApplStepCd = res.data.travelApplStepCd;
                this.getApplResultForWeatherStatus(res.data);
              } else {
                store.commit('setApplResultFail')
              }
            } else {
              store.commit('setApplResultFail')
            }
          })
          .catch(() => {
            store.commit('setApplResultFail')
          })
          .finally(() => {
            store.commit('setInitApplResult', false)
          })
    },
    async getMappingSolution() { // 솔루션 매핑여부 확인
      await store.dispatch('getMappingSolution')
          .then(res => {
            if (res.success) {
              if (res.data !== null) {
                store.commit('setSolMappingYnSuccess')
              } else {
                store.commit('setSolMappingYnFail')
              }
            } else {
              store.commit('setSolMappingYnFail')
            }
          })
          .catch(() => {
            store.commit('setSolMappingYnFail')
          })
          .finally(() => {
            store.commit('setInitSolMappingYn', false)
          })
    },
    async getApplResultForWeatherStatus(so) {  // 여행지원서 마음날씨 구분 값 조회 Api
      await store.dispatch('getApplResultForWeatherStatus', this.$_payload('so', [
        {'travelApplNo': so.travelApplNo},
        {'unitNo': so.unitNo},
        {'travelApplStepCd': so.travelApplStepCd},
        {'memberStepApplCnt': so.memberStepApplCnt},
        {'memberNo': so.memberNo},
        {'areaCritType': '01'},
        {'areaCrit': '00'},
      ]))
          .then(res => {
            if (res.success) {
              //this.weatherUrl = res.data.imgPath;
              this.weatherStatus = res.data
            } else {
              // console.log(res.msg)
              this.weatherStatus = null
            }
          })
          .catch(error => {
            console.error(error)
            this.state = "";
          })
          .finally(() => {
          })
    },
    async getMemberApplDiffMonth() { // 여행지원서 작성 경과 시간 조회
      await store.dispatch('getMemberApplDiffMonth', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'travelApplStepCd': this.travelApplStepCd}
      ]))
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                if (res.data.memberNo != null) {
                  this.usePeriodDiff = res.data.usePeriodDiff;
                  if (res.data.regDiffMonth >= 3 && res.data.travelapplAlarmDtDiff < 0) {
                    this.travelApplicationSheetOpen = true;
                    // 재 검사하기 클릭 시 이동페이지
                    // this.$router.push({ name: "travelIntro", params: { travelApplStepCd: "0001", startType: 'R' } });
                  } else if (res.data.goodsMonthCnt != null & res.data.goodsMonthCnt >= 3) {  // 솔루션 기간이 3개월 이상
                    if (res.data.cmpltPer >= 50 && res.data.isMiddelStep == 'N') {          // 유닛 중 50% 달성 && 중간검사 안함 - 중간 검사 유도
                      this.examinationOpen(0);
                    }
                  }
                  if (res.data.usePeriodDiff != null && res.data.usePeriodDiff >= 0 && res.data.usePeriodDiff <= 7 && res.data.isFianlStep == 'N') {
                    //사후검사 레이어
                    this.travelToastOpen('travelToast')
                  }
                }
              }

            } else {
              // console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    },
    async getMemberStepCnt() {
      await store.dispatch('getMemberStepCnt', this.$_payload('so', [{'travelApplNo': this.travelApplNo}, {'memberNo': this.memberNo}, {'travelApplStepCd': this.travelApplStepCd}]))
          .then(res => {
            if (res.success) {
              this.memberStepApplCnt = res.data;
              this.getProgressStep(res.data);
            } else {
              this.memberStepApplCnt = 1;
              this.goTravelPage('S');
            }
          })
          .catch(error => {
            console.error(error)
            this.memberStepApplCnt = 1;
            this.goTravelPage('S');
          })
          .finally(() => {
            store.commit('setInitApplResult', true)
          })
    },
    async getProgressStep() {
      await store.dispatch('getProgressStep', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'unitNo': 1},
        {'memberNo': this.memberNo},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
          .then(res => {
            if (res.success) {

              if (res.data != null) {
                if (10 === res.data.unitDtlSeq) {   // 완료한 여행지원서
                  if (store.getters.isApplResult === 'success') {
                    this.goTravelPage('RR');
                  } else {
                    this.goTravelPage('S');
                  }

                } else { // 진행중인 여행지원서
                  this.$confirm('작성 중인 여행지원서가 있습니다. <br>이어서 하시겠습니까?', {
                    persistent: false,
                    showClose: true,
                    actions: {
                      false: {text: '새로 작성하기'},
                      true: {text: '이어서 하기', color: '#ff4a4a'}
                    }
                  }).then(result => {
                    if (result === true) { // 이어서 하기
                      if (store.getters.isApplResult === 'success') {
                        this.goTravelPage('RR');
                      } else {
                        this.goTravelPage('S');
                      }
                    } else if (result === false) { // 새로하기
                      this.$confirm('여행지원서를 새로 작성하시면 <br>전에 진행한 여행지원서는 삭제됩니다.', {
                        actions: {
                          false: {text: '취소'},
                          true: {text: '새로 작성하기', color: '#ff4a4a'}
                        }
                      }).then(result => {
                        if (result === true) { // 새로 작성하기
                          this.setMemberResultDel()
                        }
                      })
                    }
                  })
                }
              } else {
                // console.log('res.data null!!');
                this.goTravelPage('S');
              }
            } else {
              // console.log(res.msg)
              this.pageCnt = 0;
              this.step = 0;
            }
          })
          .catch(error => {
            console.error(error)
            this.pageCnt = 0;
            this.step = 0;
          })
          .finally(() => {
          })
    },
    async setMemberResultDel() {

      // this.confirmdialog = false;

      await store.dispatch('setMemberResultDel', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'memberNo': this.memberNo},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                if (store.getters.isApplResult === 'success') {
                  this.goTravelPage('RR');
                } else {
                  this.goTravelPage('S');
                }
              }
            } else {
              // console.log(res.msg)
              this.pageCnt = 0;
              this.step = 0;
            }
          })
          .catch(error => {
            console.error(error)
            this.pageCnt = 0;
            this.step = 0;
          })
          .finally(() => {
          })
    },
    async getMainText() {
      await store.dispatch('getMainText')
          .then(res => {
            if (res.success) {
              if (res.data) {
                this.ramdomText = res.data
              }
            }
          })
    },
    async getUseOrdDtlNoGuide() {  // 유저 티켓 사용 API
      await store.dispatch('getUseOrdDtlNoGuide')
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                this.noGuide = true
              }
            } else {
              // console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {

          })
    },
    guideSelect() {
      if (this.isSamsungFire) {
        this.getFireTicketCheck('Y')
      } else {
        if (this.noGuide === false) {
          //티켓 사용
          this.movePage('/fo/ticketSelectEzn');
        } else {
          //가이드 선택
          this.movePage('/fo/guideSelect');
        }
      }

    },
    async getMemberNewAlarmCnt() {
      await store.dispatch('getMemberNewAlarmCnt', this.$_payload({'memberNo': this.memberNo}))
          .then(res => {
            if (res.success) {
              if (res.data > 0) {
                this.noticNew = true
              }
            } else {
              // console.log(res.msg);
            }
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
          })
    },
    async updateToken(token) {
      await store.dispatch('updatePushToken', this.$_payload(null, {token: token}))
          .then(() => {
            // console.log(res)
          })
          .catch(error => {
            console.error(error)
          })
    },
    /* toast click */
    snackbarClickAfter(goUrl) {
      let goUrlS = goUrl
      if (goUrlS == 'travelToastOpen') {
        /* 사후검사 */
        this.examinationOpen(1);
      } else if (goUrlS == 'guideEvalToastOpen') {
        this.$router.push({name: '가이드 평가', params: {'ordDtlNo': this.guideEvalOrdDtlNo}})
      }
      this.$refs.toastAfter.toast = false;
    },
    solutionPause() {
      if (this.travelStopYn === 'Y') {
        this.movePage('/fo/solutionPause');
      }
    },
    // 과거 진행한 티켓의 만족도검사 조회
    async goGuideEval() {
      await store.dispatch('getOldOrdDtl')
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                if (res.data.cmpltDt == null) {
                  this.$router.push({
                    name: '여행완료',
                    params: {ordDtlNo: res.data.ordDtlNo, showGuideEvaluation: res.data.guideEvalToastOpenYn}
                  }); // 여행완료
                }
                if (store.state.client.contract.allowsRealtalkService && res.data.guideEvalYn === 'N') {
                  if (res.data.guideEvalToastOpenYn === 'Y') {
                    this.guideEvalOrdDtlNo = res.data.ordDtlNo
                    this.$refs.toastAfter.toastOpen('bottom', '최근의 마음여행은 어떠셨나요?', 'guideEvalToast', 'guideEvalToastOpen', '만족도 검사하기')
                  }
                }
              }
            }
          })
    },
    async closeCoachMark() {
      await store.dispatch('checkTutorial')
          .then(res => {
            if (res.success) {
              // 튜토리얼 이후에 팝업창 출력
              store.commit('setMemberInfo', {tutorial: true})
              this.isShowCoachMark = false
              this.isShowPopup = true
            }
          })
    },
    async getTotalMissionRate() {
      this.loadedTotalMissionRate = false
      await store.dispatch('getTotalMissionRate')
          .then(res => {
            if (res.data != null) {
              this.progressRate = res.data.progressRate
            }
          })
          .catch(error => {
            console.error(error)
          }).finally(() => {
            this.loadedTotalMissionRate = true
          })
    }
  }
}
</script>
